export default {"src":"/_next/static/media/rightButton.2bbd0150.svg","height":9,"width":9};